import { Option, LocationArray, AgencyArray, ContactArray } from '../types';

enum categories {
  locations = 'Suburb',
  agencies = 'Agency',
  agents = 'Agent',
}

export const buildLocations = (locationArray: LocationArray): Option[] =>
  locationArray.map((location) => ({
    category: categories.locations,
    label: location.displayName,
    value: location.nameSlug,
    url: undefined,
    redirectToURL: false,
    avatar: undefined,
  }));

export const buildAgencies = (agencyArray: AgencyArray): Option[] =>
  agencyArray.map((agency) => ({
    category: categories.agencies,
    label: agency.agencyName,
    value: agency.profileUrl,
    url: `/real-estate-agencies/${agency.profileUrl}`,
    redirectToURL: true,
    avatar: agency.logo?.url ?? undefined,
    backgroundColour: agency.backgroundColour ?? undefined,
  }));

export const buildContacts = (contactArray: ContactArray): Option[] =>
  contactArray.map((contact) => ({
    category: categories.agents,
    label: contact.name,
    value: contact.profileUrl, // with the duplicate agent issue there are contacts with the same id value
    url: `/real-estate-agent/${contact.profileUrl}${contact.profileUrl?.endsWith('/') ? '' : '/'}`,
    redirectToURL: true,
    // Strip low resolution fallback avatars from Agency API
    avatar: contact.thumbnail?.includes('noAgentPhoto')
      ? undefined
      : contact.thumbnail,
  }));
